<div class="container-fluid">
    <ng-container *ngIf="configLoaded">
        <app-report-select
            [header]="config.header"
            [reports]="config.reports ?? true"
            [consumer]="config.consumer ?? false"
            [Date_Flat]="(config.Date_Flat ?? false) && loginType !== 'CO'"
            [AllSelection]="config.AllSelection ?? true"
            [towerSelect]="config['towerSelect'] ?? config['towerlist'] ?? false"
            [showDaterange]="loginType === 'CO' ? true : (config['showDaterange'] ?? true)"
            [showSingleDate]="config['showSingleDate'] ?? false"
            [Month_Year]="config['Month_Year'] ?? false"
            [Date_Time]="config['Date_Time'] ?? false"
            [SiteOnly]="config['SiteOnly'] ?? false"
            [showLocation]="config['showLocation'] ?? true"
            [SingleLocationDropdown]="config['SingleLocationDropdown'] ?? false"
            [ShowLocationDropdown]="config['ShowLocationDropdown'] ?? false"
            [showSites]="config['showSites'] ?? false"
            [showsubtype]="config['showsubtype'] ?? false"
            [showBillNo]="config['showBillNo'] ?? false"
            [FromToLocation]="config['FromToLocation'] ?? false"
            [Nolocation]="config['Nolocation'] ?? false"
            [Month_Range]="config['Month_Range'] ?? false"
            [dropdown]="config['dropdown'] ?? false"
            [dropdownOptions]="config['dropdownOptions']"
            [placeholder]="config['placeholder'] ?? 'State'"
            [search]="config['search'] ?? false"
            [Hours]="config['Hours'] ?? false"
            [filterConfig]="config['filterConfig'] ?? []"
            (filtersApplied)="handleFilters($event)"
            (showTable)="handlereset($event)">
        </app-report-select>
    </ng-container>

    <div class="row" *ngIf="!showtable">
        <img src="assets/DashboardIcon/applyfilters.svg" alt="" height="300px" width="400px">
    </div>

    <div class="row" *ngIf="showtable">
        <app-table
            [location]="config['location'] ?? false"
            [pageNation]="true"
            [paginationPageSizeSelector]="[10,20,50]"
            [maxRowCount]="totalCount"
            (onPageChange)="handlePageChange($event)"
            (columnFormSubmitted)="onColumnFormSubmitted($event)">
        </app-table>
    </div>
</div>
